module.exports = __webpack_public_path__ + "img/ic_default_device.e3a6e527.svg";